import React from 'react';
import styled from 'styled-components';

const BodyContent = styled.div`
  background: ${props => props.background || 'var(--very-light-bg)'};
  overflow: auto;
  padding: 24px;
  height: 100%;
  width: 100%;
  border-radius: inherit;
`;

const NoPaddingBodyContent = styled.div`
  background: ${props => props.background || 'var(--very-light-bg)'};
  overflow: hidden;
  padding: 0;
  height: 100%;
  width: 100%;
`;

class DrawerBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { tabbedDrawerBodyStyle } = this.props;

    return (
      <React.Fragment>
        {!tabbedDrawerBodyStyle && (
          <BodyContent background={this.props.background}>{this.props.children}</BodyContent>
        )}
        {tabbedDrawerBodyStyle && (
          <NoPaddingBodyContent background={this.props.background}>
            {this.props.children}
          </NoPaddingBodyContent>
        )}
      </React.Fragment>
    );
  }
}

export default DrawerBody;
